var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"scroll-wrapper",attrs:{"height":"100%"}},[_c('iframe',{attrs:{"src":_vm.tile.contentable.url,"loading":"lazy","frameborder":"0","width":"100%","height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }